import { z } from "zod";
import {
  MissionCiCaptureSnapshotSchema,
  MissionPreviewSnapshotSchema,
  MissionVisualSnapshotSchema,
} from "./mission-preview-evidence.js";
import {
  MissionCheckLogEvidenceSchema,
  MissionRepositorySnapshotSchema,
  MissionRepositorySourceSchema,
  MissionRepositorySourceSummarySchema,
  MissionRepositorySummarySchema,
} from "./mission-repository.js";
import { SharedBotInputSchema } from "./shared-bots.js";
export const MissionGuideFindingSchema = z.object({
  kind: z.literal("guide"),
  botId: z.string(),
  name: z.string(),
  configuration: z.string(),
  answer: z.string().max(24000),
  sources: z
    .array(
      z.object({
        tool: z.string(),
        resource: z.string(),
        content: z.string().max(24000),
        truncated: z.boolean(),
      }),
    )
    .max(24)
    .default([]),
  queries: z.array(z.object({ tool: z.string(), resource: z.string() })).max(24),
  capturedAt: z.string(),
  access: z.literal("read"),
  illustrative: z.boolean(),
});
const guideConfiguration = SharedBotInputSchema.omit({ password: true }).extend({
  hasPassword: z.boolean(),
  version: z.string(),
});
export const MissionGuideChangeSchema = z.object({
  kind: z.literal("guide_change"),
  botId: z.string(),
  name: z.string(),
  before: z.string().nullable(),
  after: z.string(),
  decisionId: z.string(),
  changedFields: z.array(z.string()),
  observation: z.enum(["application", "readback"]).optional(),
  beforeConfiguration: guideConfiguration.nullable().optional(),
  afterConfiguration: guideConfiguration.optional(),
  preservedCredentials: z
    .object({ password: z.boolean(), shareLink: z.boolean() })
    .nullable()
    .optional(),
  capturedAt: z.string(),
});
export const MissionReviewSnapshotSchema = z.object({
  kind: z.literal("review"),
  reviewId: z.string(),
  rubric: z.string(),
  provider: z.string(),
  model: z.string(),
  calibrationPassed: z.boolean(),
  assignmentKeys: z.array(z.string()),
  evidenceIds: z.array(z.string()),
  reason: z.string().max(4000),
  capturedAt: z.string(),
  costUsd: z.number().nonnegative().nullable(),
});
export const MissionReleaseSnapshotSchema = z.object({
  kind: z.literal("release"),
  decisionId: z.string(),
  provider: z.string(),
  action: z.enum(["merge", "deploy"]),
  resource: z.string(),
  revision: z.string(),
  previousRevision: z.string().nullable(),
  externalId: z.string(),
  url: z.string().url().nullable(),
  capturedAt: z.string(),
  recovery: z.string(),
});
export const MissionCollectedEvidenceSchema = z.union([
  MissionCheckLogEvidenceSchema,
  MissionRepositorySnapshotSchema,
  MissionRepositorySourceSchema,
  MissionPreviewSnapshotSchema,
  MissionVisualSnapshotSchema,
  MissionCiCaptureSnapshotSchema,
  MissionGuideFindingSchema,
  MissionGuideChangeSchema,
  MissionReviewSnapshotSchema,
  MissionReleaseSnapshotSchema,
]);
export const MissionCollectedSummarySchema = z.union([
  MissionRepositorySummarySchema,
  MissionRepositorySourceSummarySchema,
  MissionCheckLogEvidenceSchema,
  MissionPreviewSnapshotSchema,
  MissionVisualSnapshotSchema,
  MissionCiCaptureSnapshotSchema,
  MissionGuideFindingSchema,
  MissionGuideChangeSchema,
  MissionReviewSnapshotSchema,
  MissionReleaseSnapshotSchema,
]);

export const MissionDeliveryStateSchema = z.object({
  status: z.enum(["intent", "submitted", "verified", "failed", "unknown"]),
  provider: z.string(),
  startedAt: z.string(),
  observedAt: z.string().nullable().default(null),
  previousRevision: z.string().nullable(),
  externalId: z.string().nullable(),
  detail: z.string().max(1000),
});
